import React from "react";
import Graph from "../../../../etc/Graph";

const SChart = (parent) => {
    const record = parent.record;
    return (
        <>
            <div className="mt-65">
                <div className="row row-cols-2 ml-px-n12 mr-px-n12">
                    <div className="col pl-px-12 pr-px-12">
                        <div className="d-flex justify-content-between align-items-center mb-px-26">
                            <div className="d-flex align-items-center">
                                <h3 className="con-title">발표논문수, 비율</h3>
                            </div>
                        </div>
                        <div className="basic-chart-data">
                            <div
                                className="d-flex w-100 h-100 align-items-center justify-content-center bg-gray">이
                                태그는 샘플입니다.
                            </div>
                        </div>
                    </div>
                    <div className="col pl-px-12 pr-px-12">
                        <div className="d-flex justify-content-between align-items-center mb-px-26">
                            <div className="d-flex align-items-center">
                                <h3 className="con-title">연구자 등록한 학술지 분포</h3>
                            </div>
                        </div>
                        <div className="basic-chart-data">
                            <div
                                className="d-flex w-100 h-100 align-items-center justify-content-center bg-gray">이
                                태그는 샘플입니다.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-65">
                <div className="row row-cols-2 ml-px-n12 mr-px-n12">
                    <div className="col pl-px-12 pr-px-12">
                        <div className="d-flex justify-content-between align-items-center mb-px-26">
                            <div className="d-flex align-items-center">
                                <h3 className="con-title">연구자가 인용한 학술지 분포</h3>
                            </div>
                        </div>
                        <div className="basic-chart-data">
                            <div
                                className="d-flex w-100 h-100 align-items-center justify-content-center bg-gray">이
                                태그는 샘플입니다.
                            </div>
                        </div>
                    </div>
                    <div className="col pl-px-12 pr-px-12">
                        <div className="d-flex justify-content-between align-items-center mb-px-26">
                            <div className="d-flex align-items-center">
                                <h3 className="con-title">연구자의 논문이 인용되는 학술지 추이</h3>
                            </div>
                        </div>
                        <div className="basic-chart-data">
                            <div
                                className="d-flex w-100 h-100 align-items-center justify-content-center bg-gray">이
                                태그는 샘플입니다.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-65">
                <div className="d-flex justify-content-between align-items-center mb-px-26">
                    <div className="d-flex align-items-center">
                        <h3 className="con-title">저자간 인용관계</h3>
                    </div>
                </div>
                <div className="basic-chart-data lg">
                    <div className="d-flex w-100 h-100 align-items-center justify-content-center bg-gray">이 태그는
                        샘플입니다.
                    </div>
                </div>
            </div>
            <div className="mt-65">
                <div className="d-flex justify-content-between align-items-center mb-px-26">
                    <div className="d-flex align-items-center">
                        <h3 className="con-title">공동연구자</h3>
                    </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                    <button className="btn-tab-nav mr-1 active-color-lightblue active">리스트</button>
                    <button className="btn-tab-nav mr-1 active-color-lightblue">그래프</button>
                </div>
                <div>
                    <div className="tab-data active">
                        <div className="basic-chart-data md">
                            <div
                                className="d-flex w-100 h-100 align-items-center justify-content-center bg-gray">이
                                태그는 샘플입니다.
                            </div>
                        </div>
                    </div>
                    <div className="tab-data active">
                        <div className="basic-chart-data md">
                            <div
                                className="d-flex w-100 h-100 align-items-center justify-content-center bg-gray">이
                                태그는 샘플입니다.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SChart;
